import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { updateOrderParam } from "features/hublink/core/tei-hub-link.param";
import {
  GetTeiHubLinkLogisticReceiveOrderResponse,
  GetTeiHubLinkLogisticReceiveOrderRepository,
} from "features/hublink/data/tei-hub-link.repository";

export enum TeiHubLinkLogisticReceiveOrder {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: TeiHubLinkLogisticReceiveOrder;
  message: string;
}

const initialState: InitialState = {
  status: TeiHubLinkLogisticReceiveOrder.initial,
  message: "",
};

export const teiHubLinkLogisticReceiveOrder = createAsyncThunk(
  "teiHubLinkLogisticReceiveOrder",
  async (param: updateOrderParam, { rejectWithValue }) => {
    try {
      const response: GetTeiHubLinkLogisticReceiveOrderResponse =
        await GetTeiHubLinkLogisticReceiveOrderRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const teiHubLinkLogisticReceiveOrderSlice = createSlice({
  name: "teiHubLinkLogisticReceiveOrder",
  initialState,
  reducers: {
    resetTeiHubLinkLogisticReceiveOrder: (state) => {
      state.status = TeiHubLinkLogisticReceiveOrder.initial;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(teiHubLinkLogisticReceiveOrder.pending, (state) => {
        state.status = TeiHubLinkLogisticReceiveOrder.inProgress;
      })
      .addCase(teiHubLinkLogisticReceiveOrder.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = TeiHubLinkLogisticReceiveOrder.success;
          state.message = message;
        }
      })
      .addCase(teiHubLinkLogisticReceiveOrder.rejected, (state, action) => {
        state.status = TeiHubLinkLogisticReceiveOrder.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectTeiHubLinkLogisticReceiveOrder = (state: RootState) =>
  state.teiHubLinkLogisticReceiveOrder;

export const { resetTeiHubLinkLogisticReceiveOrder } =
  teiHubLinkLogisticReceiveOrderSlice.actions;
export default teiHubLinkLogisticReceiveOrderSlice.reducer;
